/* eslint-disable */
import React, { useRef } from 'react';
import parse from 'html-react-parser';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';
import Avatar from '@mui/material/Avatar';
import { Grid, Paper, Toolbar, Divider, Tooltip, Chip, Stack, Skeleton } from '@mui/material';
import InsertLinkOutlinedIcon from "@mui/icons-material/InsertLinkOutlined";
import moment from 'moment';

export const CompanyJobDetail = ({ jobDetails, selectedJobLoader, selectedJobId, jobsLoading, jobsLoadComplete, hasJobs }) => {
  const scrollRef = useRef(null);

  const scrollBodySx = {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    overflowX: "hidden",
    p: 1.5,
  };

  return (
    <Paper elevation={2} sx={{ height: "100%", flex: 1, minHeight: 0, width: "100%", display: "flex", flexDirection: "column", borderRadius: "8px", overflow: "hidden" }}>
      <Toolbar
        sx={{
          flexShrink: 0,
          pl: { sm: 2 },
          pr: { xs: 1, sm: 1 },
          minHeight: "42px !important",
          bgcolor: "#fff",
          borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
        }}
      >
        <Typography sx={{ fontWeight: 500, margin: 0 }} id="tableTitle" component="div">
          Job Detail
        </Typography>
      </Toolbar>

      <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
      {!jobsLoadComplete || jobsLoading || selectedJobLoader ? (
        <Box sx={{ ...scrollBodySx }}>
          <Stack spacing={1.5}>
            <Skeleton variant="text" width="50%" height={36} />
            <Stack direction="row" spacing={1}>
              <Skeleton variant="text" width={140} />
              <Skeleton variant="text" width={90} />
            </Stack>
            <Skeleton variant="rectangular" height={260} />
          </Stack>
        </Box>
      ) : !hasJobs ? (
        <Box
          sx={{
            flex: 1,
            height: "100%",
            minHeight: 280,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <Typography variant="subtitle1" color="text.secondary" sx={{ m: 0 }}>
            No Job Selected
          </Typography>
        </Box>
      ) : jobDetails != null && selectedJobId ? (
        <>
          <Box
            sx={{
              flexShrink: 0,
              px: 1.5,
              py: 1,
              bgcolor: "#fff",
              borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
            }}
          >
            <Grid container spacing={1} alignItems="center">
              <Grid item xs="auto">
                <Avatar sx={{ bgcolor: "rgb(169, 169, 169)" }}>
                  <BusinessCenterIcon />
                </Avatar>
              </Grid>
              <Grid item xs sx={{ minWidth: 0, overflow: "hidden" }}>
                <Typography
                  variant="h6"
                  noWrap
                  sx={{
                    fontWeight: 600,
                    fontSize: "18px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  title={jobDetails?.title}
                >
                  {jobDetails?.title}
                </Typography>
                <Typography variant="caption" sx={{ color: "text.secondary", display: "block" }}>
                  Location:{" "}
                  {jobDetails?.is_remote === 1
                    ? "Remote"
                    : jobDetails?.location || "N/A"}
                  {" · "}
                  Posted: {moment(jobDetails.modified).fromNow()}
                </Typography>
              </Grid>
              <Grid item xs="auto">
                <Tooltip
                  title={
                    jobDetails?.source === "WSJ"
                      ? `Web Scrapping Job - ${jobDetails.source_name || ""}`
                      : jobDetails?.source === "OSJ"
                        ? `Outlook Scrapping Job - ${jobDetails.source_name || ""}`
                        : jobDetails?.source === "JNP"
                          ? `Jobsnprofiles Posted Job - ${jobDetails.source_name || ""}`
                          : jobDetails?.source === "CEIPAL"
                            ? `CEIPAL Posted Job - ${jobDetails.source_name || ""}`
                            : "N/A"
                  }
                >
                  <Chip
                    size="small"
                    label={
                      jobDetails?.source !== "CEIPAL"
                        ? `${jobDetails.source_name ? `${jobDetails.source_name} | ` : ""}${jobDetails.source}`
                        : jobDetails.source
                    }
                  />
                </Tooltip>
                {jobDetails?.joblink && (
                  <Tooltip title="Job Link">
                    <InsertLinkOutlinedIcon
                      onClick={() => handlesourcelinkClick(jobDetails?.joblink)}
                      sx={{ fontSize: 18, ml: 0.5, cursor: "pointer", verticalAlign: "middle" }}
                    />
                  </Tooltip>
                )}
              </Grid>
            </Grid>
          </Box>
          <Box ref={scrollRef} sx={scrollBodySx} className="infinityscroll">
            <Box className="job-description" sx={{ fontSize: "12px" }}>
              {jobDetails?.description != null && typeof jobDetails?.description === "string" ? (
                parse(jobDetails.description)
              ) : (
                "N/A"
              )}
            </Box>
            {jobDetails?.skills && (
              <Box sx={{ mt: 2 }}>
                <Typography sx={{ fontWeight: 700, fontSize: "14px", mb: 1 }}>
                  Skills
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  {jobDetails.skills.split(",").map((skill, index) => (
                    <Chip key={index} label={skill.trim()} size="small" sx={{ bgcolor: "#f5f5f5" }} />
                  ))}
                </Box>
              </Box>
            )}
          </Box>
        </>
      ) : (
        <Box
          sx={{
            flex: 1,
            height: "100%",
            minHeight: 280,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            width: "100%",
          }}
        >
          <Typography variant="subtitle1" color="text.secondary" sx={{ m: 0 }}>
            No Job Selected
          </Typography>
        </Box>
      )}
      </Box>
    </Paper>
  );
};

const handlesourcelinkClick = (jobLink) => {
  if (jobLink) {
    window.open(jobLink, "_blank");
  } else {
    alert("Job link is not available");
  }
};

export default CompanyJobDetail;
